import React, { FC } from "react";
import { IWorkCalendarDay } from "../../../utils";
import { HolidayIcon, Information } from "../../svgs";

interface DayIconProps {
  workCalendarDay: IWorkCalendarDay;
}

export const DayIcon: FC<DayIconProps> = ({ workCalendarDay }) => {
  return (
    <>
      { workCalendarDay.type === 'holiday' && (
        <HolidayIcon tooltip={workCalendarDay.title} />
      )}

      {workCalendarDay.type !== 'holiday' && workCalendarDay.type !== 'weekend' && (
        <Information tooltip={workCalendarDay.title} />
      )}
    </> 
  )
}